import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../shared/utils';

@Pipe({ name: 'formatNumber' })
export class FormatNumberPipe implements PipeTransform {
    transform(value: number | undefined, convertUnits?: boolean, format?: string, locale?: string): string {
        return Utils.formatNumber(value, convertUnits, format, locale);
    }
}